import { Component, OnDestroy, OnInit } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { ActionButtonComponent } from 'libs/ui/src/lib/action-button/action-button.component';
import { ProjectPackConversionDataGridService } from './project-pack-conversion-data-grid.service';
import {
  ProjectsFacade,
  SharedFacade,
  customDecode,
  customEncode,
  decrypt,
  encrypt,
} from '@piqet-angular/data';
import { ActivatedRoute, Router } from '@angular/router';
import { GridIconComponent } from 'libs/ui/src/lib/grid-icon/grid-icon.component';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ViewportScroller } from '@angular/common';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { catchError, of, finalize, Subscription } from 'rxjs';
import { AccessPermissionService, CustomModalService } from '@piqet-angular/shared';
import { ProjectPackMaterialListDataGridService } from '../project-material-list/project-material-list-data-grid.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'piqet-angular-project-pack-conversion',
  templateUrl: './project-pack-conversion.component.html',
  styleUrls: ['./project-pack-conversion.component.scss'],
})
export class ProjectPackConversionComponent implements OnInit, OnDestroy {
  columnDefs: ColDef[];
  costColumnDefs: ColDef[];
  activatedRouteProjectId: any;
  projectPackConversionDataPayload: any;
  activatedRoute: any;
  gridNameConversion: string = 'Pack conversion';
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    iconsOfTransport: GridIconComponent,
  };
  searchData: any = '';
  sortColumnState: any;
  scenarioId: any;
  nextRoute: any;
  packageScenarioId: any;
  headerData = {
    materialName: 'Summary of conversion',
  };
  event: any;
  menuDataForRouting: any;
  isHideSideBar = false;
  packConversionList: any;
  navigationConfig: any;
  copyPackConversion: Subscription;
  deletePackConversion: Subscription;
  editConversionSuccess: Subscription;
  eId: any;
  backRouteType: any;
  showEdit: boolean = false;
  constructor(
    private PpojectPackConversionDataGridService: ProjectPackConversionDataGridService,
    private sharedService: SharedService,
    private viewportScroller: ViewportScroller,
    public sharedFacade: SharedFacade,
    public projectFacade: ProjectsFacade,
    public route: ActivatedRoute,
    private router: Router,
    private projectService: ProjectsService,
    private modal: CustomModalService,
    private projectPackMaterialDataGridService: ProjectPackMaterialListDataGridService,
    private toaster: ToastrService,
    private projectPackConversionDataGridService: ProjectPackConversionDataGridService,
    private accessService: AccessPermissionService
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    const url = location.href.split('/');
    this.activatedRouteProjectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
    this.route.queryParams.subscribe((values: any) => {
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.scenarioId = value['id'] || values?.id;
      this.packageScenarioId = value['packageScenarioId'] || values?.packageScenarioId;
      this.eId = value['eId'] || values?.id;
      this.getPackConversionList();
    });

    this.sharedService.menuData$.subscribe((res: any) => {
      this.menuDataForRouting = res;
    });

    this.columnDefs =
      this.PpojectPackConversionDataGridService.getProjectPackConversionDataColumn();
    this.costColumnDefs =
      this.PpojectPackConversionDataGridService.getProjectPackConversionDataColumnForCost();
    this.projectPackConversionDataPayload =
      this.PpojectPackConversionDataGridService.getPackConversionProjectPayload(this.searchData);

    this.copyPackConversion =
      this.projectPackConversionDataGridService.copyPackConversionData$.subscribe(
        async (copyData: any) => {
          await this.openCopyModal(copyData[0], copyData[1]);
        }
      );

    this.deletePackConversion =
      this.projectPackConversionDataGridService.deletePackConversionData$.subscribe(
        async (deleteData: any) => {
          await this.deletePackConversionData(deleteData[0]);
        }
      );

    this.editConversionSuccess =
      this.projectPackConversionDataGridService.editConversionSuccessData$.subscribe(async () => {
        this.getPackConversionList();
      });
  }

  ngOnInit() {
    this.showEdit = this.accessService.hasPermission('edit', this.activatedRoute, 'packaging');
    this.viewportScroller.scrollToPosition([0, 0]);
  }

  async getPackConversionList() {
    const packConversionList = (
      await this.projectService.getMyAllProjectPackConversionList(
        this.scenarioId,
        this.activatedRouteProjectId
      )
    ).data;
    packConversionList?.conversionList.map((item: any) => {
      item.componentTransportDetail.map((data: any) => {
        data['cityName'] = data.originName;
      });
    });
    this.packConversionList = packConversionList;
    this.navigationConfig = {
      scenarioId: this.scenarioId,
      packageScenarioId: this.packageScenarioId,
      eId: this.eId,
      activatedRouteProjectId: this.activatedRouteProjectId,
      activatedRoute: this.activatedRoute,
      isProjectLocked: this.packConversionList?.isLockProject,
      isProductPage: true,
    };
  }

  async addMatierialModal(scenarioId: any, id: any, isMaterial: any, label?: any) {
    let response = await this.projectService.getAddEditPackMaterialModalAsync(
      scenarioId,
      id,
      isMaterial
    );
    this.modal.invoke('newAddProjectMaterial', {
      initialState: {
        newMyProjectsPackMaterial: response.data,
        label: label,
        addTransportScenarioColDef:
          this.projectPackMaterialDataGridService.getTransportModalForManualLocationDataColumn(),
        distanceProcessColumnDef:
          this.projectPackMaterialDataGridService.getTransportModalForManualDestinationDataColumn(),
        customTransportColumnDef:
          this.projectPackMaterialDataGridService.getCustomTransportItemsList(),
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.saveNewMyProjectPackMaterialEvent.subscribe(
      (saveNewMyProjectPackMaterialEvent: any) => {
        this.addPackConversion(saveNewMyProjectPackMaterialEvent);
      }
    );
  }

  addPackConversion(data: any) {
    this.projectService
      .addEditMyAllProjectPackMaterialData(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getPackConversionList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  openCopyModal(data: any, label: any) {
    this.modal.invoke('newCopyPackMaterial', {
      initialState: {
        projectName: data.name,
        modalLable: label,
        componentId: data.componentId,
      },
      class: 'modal-lg',
    });
    return of(
      this.modal.ref?.content.saveNewPackMaterialCopy.subscribe((data: any) => {
        this.copyPackConversionData(data);
      })
    );
  }

  copyPackConversionData(data: any) {
    this.projectService
      .copyProjectPackMaterial(this.scenarioId, data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.modal.close();
          this.getPackConversionList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  deletePackConversionData(data: any) {
    this.projectService
      .deleteProjectPackMaterialList(data.componentId)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getPackConversionList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  ngOnDestroy() {
    this.copyPackConversion.unsubscribe();
    this.deletePackConversion.unsubscribe();
  }
}
